module.exports = __webpack_public_path__ + "img/m-logo.339ba301.png";